








import { Component, Prop, Vue} from 'vue-property-decorator';
import * as Common from "@/agiles/common";

@Component
export default class Topics extends Vue {
  @Prop({default:''}) public item : Common.Topics;

   public getDescription(){
       if (this.item.content.length < 50) return this.item.content;
       else return this.item.content.substring(0,49) + '...';
   }
   public get isNew(){
       var dt = new Date();
       dt.setHours(dt.getHours() -72);
    //    return new Date(Date.parse(this.item.lastUpdatedOn as any)) > dt;
       return this.item.lastUpdatedOn > dt;    
   }
    public onClick(){
        this.$router.push(String.format('/operation/Topics?id={0}&isAdmin={1}', this.item.id,this.item.isAdmin));
    }
}
